import React from 'react';
import './StandardCreditCardOffer.scss';

const AnnualFee = ({ datatestid, annualFeeDetails }) => {
  return (
    <div className="cardAttributes__block introPurchaseBlock AnnualFeeBlock">
      <div
        className="cardAttributes__blockTitle annualFeeTitle"
        data-testid="annualFeeLabel"
      >
        Annual Fee
      </div>
      <div
        className="cardAttributes__blockContent annualFee"
        data-testid={`${datatestid}-annualFee`}
      >
        {annualFeeDetails}
      </div>
    </div>
  );
};

export default AnnualFee;
